<template>
    <div>
        <el-form :model="userForm" :rules="formRules" label-position="right" ref="userForm" label-width="100px" class="demo-ruleForm">
            <el-col :span="12">
            <el-form-item label="用户姓名" prop="userName">
                <el-input ref="userNameEl" v-model="userData.userName" style="width: 98%" placeholder="输入用户姓名" ></el-input>
            </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="用户帐号" prop="userAccount">
                    <el-input v-model="userForm.userAccount" :readonly="true" readonly style="width: 98%" placeholder="请输入地址"></el-input>
                </el-form-item>
            </el-col>
        </el-form>
        <el-table
            ref="myRoleTable"
            background="true"
            :height="tableHeight"
            :data="tableData"
            border style="width: 100%;">
            <el-table-column type="selection" width="40"/>
            <el-table-column type="index" label="序号" fixed="left" width="50"/>
            <el-table-column prop="tenantPid" label="企业编号" width="110"/>
            <el-table-column prop="roleName" label="角色名称" width="110"/>
            <el-table-column prop="roleRemark" label="备注信息" />
        </el-table>
        <div style="text-align: center">
            <el-button type="primary" style="width: 120px" :disabled="saveButState" @click="submitForm()" v-html="saveButValue"></el-button>
            <el-button type="danger" style="width: 120px" @click="closeWindow()">关 闭</el-button>
        </div>
        <!--选择企业-->
        <el-dialog
                title="选择企业"
                width="800px"
                :visible.sync="innerVisible"
                append-to-body>
            <SelectTenantDialog :setSelectedTenant="setSelectedTenant"></SelectTenantDialog>
        </el-dialog>
    </div>
</template>
<script>
    import SelectTenantDialog from "@/components/dialog/SelectTenantDialog.vue"
    import {appjs} from "@/utiljs/apputil";
    export default {
        components: {
            SelectTenantDialog
        },
        props: {
            userData:{
                type: Object
            },
            closeWindow: {
                type: Function
            }
        },
        data() {
            return {
                saveButValue: '更 新',
                saveButState: false,
                innerVisible:false,
                tableData:[],
                tableHeight: '280px',
                userForm: {
                    userPid: '',
                    userName: '',
                    userAccount: '',
                    roleIds:''
                },
                formRules: {
                    userName: [
                        { required: true, message: '请输入用户姓名', trigger: 'blur' }
                    ],
                    userAccount: [
                        { required: true, message: '请输入用户帐号', trigger: 'blur' }
                    ]
                }
            }
        },
        created() {
            this.userForm = this.userData;
            this.loadRoleTableData();
        },
        methods:{
            resertForm() {
                this.saveButValue = '更 新';
                this.saveButState = false;
                this.userForm = this.userData;
                this.loadRoleTableData();
            },
            showSelectTenantWindow() {
                this.innerVisible = true;
            },
            setSelectedTenant(tenantData){
                this.userForm.tenantPid=tenantData.tenantPid;
                this.userForm.tenantName=tenantData.tenantName;
                this.$refs.tenantNameEl.focus();
                this.$refs.userNameEl.focus();
                this.innerVisible = false;
            },
            loadRoleTableData(){
                let load = appjs.loading();
                let _self = this;
                let params = this.searchForm;
                appjs.httpRequest('role/queryAllRole',params).then(
                    (data)=>{
                        if(data.retCode&&data.retCode!="ok"){
                            appjs.showErrorMsg(data.retMsg)
                        }else{
                            _self.tableData = data.dataList;
                            if(_self.userData.roleIds!=null){
                                let arrs = _self.userData.roleIds.split(',');
                                this.$nextTick(()=>{
                                    _self.tableData.forEach((item)=>{
                                        arrs.forEach((roleId)=>{
                                            if(item.rolePid==roleId){
                                                this.$refs.myRoleTable.toggleRowSelection(item,true);
                                            }
                                        })
                                    })

                                })
                            }
                            this.$refs.myRoleTable.bodyWrapper.scrollTop =0;
                        }
                        appjs.unloading(load);
                    }
                ).catch((errmsg)=>{
                    appjs.showErrorMsg(errmsg)
                    appjs.unloading(load);
                });
            },
            submitForm() {
                let roleIds = "";
                this.$refs.myRoleTable.store.states.selection.forEach(item=>{
                    roleIds += item.rolePid+",";
                })
                this.userForm.roleIds = roleIds;
                this.$refs['userForm'].validate((valid) => {
                    if (valid) {
                        let params = this.userForm;
                        if(this.userForm.roleIds==""){
                            appjs.showWarningMsg("请选择角色信息")
                            return;
                        }
                        this.saveButValue = '更新中....'
                        this.saveButState = true;
                        let _self = this;
                        appjs.httpRequest('user/updateUser',params).then((data)=>{
                            if(data.retCode&&data.retCode!="ok"){
                                appjs.showErrorMsg(data.retMsg);
                                _self.saveButValue = '更 新';
                                _self.saveButState = false;
                            }else{
                                _self.saveButValue = '更新成功';
                                _self.closeWindow(data.retMsg);
                            }
                        }).catch((error)=>{
                            _self.saveButState = false;
                            _self.loginText = '更 新';
                            appjs.showErrorMsg("异常：" + error)
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    }
</script>
